import { message } from 'antd';
import { FC, memo, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { instance } from 'utils/api';
import { StyledButton } from './styled';
import { IResendButtonProps } from './types';

const ResendButton: FC<IResendButtonProps> = ({ route, email, text }) => {
  // translation
  const { t } = useTranslation();
  // states
  const [seconds, setSeconds] = useState(60);
  // refs
  const interval = useRef<NodeJS.Timeout | null>(null);

  useEffect(
    () => () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    },
    []
  );

  useEffect(() => {
    if (seconds <= 0) {
      if (interval.current) {
        clearInterval(interval.current);
      }

      setSeconds(60);
    }
  }, [seconds]);

  const onClick = useCallback(() => {
    if (seconds !== 60) return;

    instance
      .post(route, {
        email
      })
      .then(() => {
        message.success(t('auth.successfully_sent'));
        setSeconds(59);
        interval.current = setInterval(() => {
          setSeconds(prev => prev - 1);
        }, 1000);
      });
  }, [email, route, seconds, t]);

  const renderTime = () =>
    seconds !== 60 && `00:${seconds > 9 ? seconds : `0${seconds}`}`;

  return (
    <StyledButton type="link" onClick={onClick} disabled={seconds !== 60}>
      {text} {renderTime()}
    </StyledButton>
  );
};

export default memo(ResendButton);
